import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { WorkoutsSignupForm } from '../components/WorkoutsSignup';
import '../styles/workouts.css';

const WorkoutBuilderPage = () => {
  useEffect(() => {
    document.title = 'Build Your Own Workout | GoCalFit';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'Free workout builder — pick 25 or 35 minutes, inside or outside, full body, upper, or core. No equipment, no signup.');
  }, []);

  return (
    <div className="workouts-page" data-testid="workouts-builder-page">
      <div className="builder-back-row">
        <Link to="/workouts" className="builder-back-link" data-testid="builder-back-link">
          <ArrowLeft size={14} /> GoCalFit
        </Link>
      </div>

      {/* Embedded EARTHBORN workout builder */}
      <iframe
        src="/api/public/files/earthborn"
        title="EARTHBORN Workout Builder"
        className="workouts-iframe"
        loading="lazy"
        data-testid="workouts-iframe"
      />

      {/* Email Signup Section */}
      <section className="workouts-signup-section">
        <div className="workouts-signup-container">
          <h2 className="workouts-signup-title">Want the next one sent to you?</h2>
          <WorkoutsSignupForm source="earthborn" testPrefix="workouts" />
        </div>
      </section>
    </div>
  );
};

export default WorkoutBuilderPage;
